import { useNavigate, useParams } from 'react-router';
import React from 'react';
import { MeetingDetailsContent } from 'src/meetings/detail/MeetingDetailsContent';

export const MeetingDetailPage = () => {
  const navigate = useNavigate();
  const { eventId, eventTab } = useParams<{
    eventId: string;
    eventTab?: string;
  }>();
  return (
    eventId && (
      <MeetingDetailsContent
        eventId={eventId}
        onDelete={() => navigate('/meetings')}
        basePath={`/meetings/${eventId}`}
        tab={eventTab}
      />
    )
  );
};
